'use strict';

const _default = require('./themes/default.js');

var themeDef = {
  defaultTheme: _default
};

module.exports = themeDef;
